import { theme } from '@theme/.';
export class Address {
  line1: string;
  line2: string;
  country: string;
  subdivision: string;
  city: string;
  postal: string;
  sector: string;
  type: number;
  full: string;

  constructor({
    line1 = '',
    line2 = '',
    country = '',
    subdivision = '',
    city = '',
    postal = '',
    sector = '',
    type = 1,
    full = ''
  } = {}) {
    this.line1 = line1 || '';
    this.line2 = line2 || '';
    this.country = country || '';
    this.subdivision = subdivision || '';
    this.city = city || '';
    this.sector = sector || '';
    this.postal = postal || '';
    this.type = type || 1;
    this.full = full || '';
  }

  isEmpty() {
    return Object.entries(this)
      .filter(([key]) => ['country', 'type'].includes(key)) // filter this out because it will never be empty
      .every(([, value]) => !value);
  }

  // this method will be used to filter out partially filled out addresses
  // we don't make them required in registration and can't mark fields individually
  // but we can ignore it if it's not fully valid (eg. all required fields filled)
  isValid() {
    // TODO: perform this validation using FormBuilder
    let isValid: Boolean = true;  // If address form has its required fields entered?

    // evaluate each field. if blank set to false, otherwise keep the value it had previously
    isValid = this.line1 ? isValid : false;
    isValid = this.country ? isValid : false;
    isValid = this.subdivision ? isValid : false;
    isValid = this.city ? isValid : false;
    // Only DR requires sector field 
    isValid = this.country == 'DO' && !this.sector ? false : isValid;  
    // countries other than DR require postal field
    isValid = this.country != 'DO' && !this.postal ? false : isValid;
    
    return isValid;
  }
}
